import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-legacy-catalog-redirect',
  template: ''
})
export class LegacyCatalogRedirectComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const search = (this.route.snapshot.paramMap.get('search') || '').replace(/\//g, '').trim();

    void this.router.navigate(['/new-catalog'], {
      queryParams: {
        query: search || null
      },
      replaceUrl: true
    });
  }
}
